/* eslint-disable */
import { Folder, ChevronRight, Pencil, Trash2 } from "lucide-react";
import { categoryMeta } from "./api";

// A bundle (folder) rendered in the same list as document rows, so files
// and folders live together. Clicking drills into the bundle.
export default function BundleRow({ bundle, onOpen, onRename, onDelete, showCategory = true, variant = "row" }) {
  const meta = categoryMeta(bundle.category);
  const open = () => onOpen(bundle);
  const onKey = (e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      open();
    }
  };

  if (variant === "tile") {
    return (
      <div
        className="docs-tile docs-tile-bundle"
        role="button"
        tabIndex={0}
        aria-label={`Open bundle ${bundle.name}`}
        onClick={open}
        onKeyDown={onKey}
        style={{ position: "relative" }}
      >
        <div className="docs-tile-top">
          <div
            className="docs-tile-icon"
            style={{ color: meta.color, background: meta.bg }}
          >
            <Folder size={22} strokeWidth={1.8} />
          </div>
          <span className="docs-row-badge rb-bundle">Bundle</span>
        </div>
        <div className="docs-tile-title" title={bundle.name}>
          {bundle.name}
        </div>
        <div className="docs-tile-meta">
          {showCategory && (
            <>
              <span style={{ color: meta.color }}>{meta.label}</span>
              <span className="docs-row-dot">·</span>
            </>
          )}
          <span>
            {bundle.document_count} file{bundle.document_count === 1 ? "" : "s"}
          </span>
        </div>
        {(onRename || onDelete) && (
          <div className="docs-cat-actions" onClick={(e) => e.stopPropagation()}>
            {onRename && (
              <button className="docs-cat-edit" title="Rename folder" onClick={() => onRename(bundle)}>
                <Pencil size={12} />
              </button>
            )}
            {onDelete && (
              <button className="docs-cat-delete" title="Delete folder" onClick={() => onDelete(bundle)}>
                <Trash2 size={12} />
              </button>
            )}
          </div>
        )}
      </div>
    );
  }

  return (
    <div
      className="docs-row docs-row-bundle"
      role="button"
      tabIndex={0}
      aria-label={`Open bundle ${bundle.name}`}
      onClick={open}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          open();
        }
      }}
    >
      <div
        className="docs-row-icon"
        style={{ color: meta.color, background: meta.bg }}
      >
        <Folder size={18} strokeWidth={1.9} />
      </div>
      <div className="docs-row-main">
        <div className="docs-row-title-line">
          <span className="docs-row-title">{bundle.name}</span>
          <span className="docs-row-badge rb-bundle">Bundle</span>
        </div>
        <div className="docs-row-meta">
          {showCategory && (
            <>
              <span className="docs-row-cat" style={{ color: meta.color }}>
                {meta.label}
              </span>
              <span className="docs-row-dot">·</span>
            </>
          )}
          <span>
            {bundle.document_count} file{bundle.document_count === 1 ? "" : "s"}
          </span>
        </div>
      </div>
      {(onRename || onDelete) ? (
        <div style={{ display: "flex", gap: 4 }} onClick={(e) => e.stopPropagation()}>
          {onRename && (
            <button className="docs-cat-edit" title="Rename folder" onClick={() => onRename(bundle)}>
              <Pencil size={12} />
            </button>
          )}
          {onDelete && (
            <button className="docs-cat-delete" title="Delete folder" onClick={() => onDelete(bundle)}>
              <Trash2 size={12} />
            </button>
          )}
        </div>
      ) : (
        <ChevronRight size={18} className="docs-row-chevron" />
      )}
    </div>
  );
}
